// #430 — Formatação "Notificações em uma linha" (toggle oneLineNotifications).
// Módulo puro (sem React/PrimeReact) para o merge título+mensagem usado pelo
// choke point do ToastProvider e testável isoladamente.

// Títulos default das quatro severidades — não carregam informação além da
// cor/ícone do toast, então caem no formato one-line.
const GENERIC_TITLES = new Set(["sucesso", "erro", "aviso", "informação"]);

// Durações atuais por severidade (caracterizadas em
// toastGlobal.characterization.test.js) — o modo one-line preserva os tempos
// do modo regular (erro continua 5 s legível), não os 2,5 s do showCompact.
export const TOAST_LIFE = {
  success: 3000,
  error: 5000,
  warn: 4000,
  info: 3000,
};

const norm = (s) =>
  String(s ?? "")
    .trim()
    .toLowerCase();

/**
 * Converte o par título/mensagem do toast regular em uma única linha sem
 * perder informação decisória (inventário completo em ANALISE-430.md):
 *   - quebras de linha viram " — " (ex.: motivo de rejeição, #366);
 *   - título genérico ("Sucesso"/"Erro"/"Aviso"/"Informação") é suprimido;
 *   - título redundante (a mensagem já começa com ele, case-insensitive,
 *     ex.: "Ordem Executada" / "Ordem executada: …") é suprimido;
 *   - título informativo (a mensagem não o contém) vira prefixo "Título: ".
 */
export const toOneLine = (title, message) => {
  const line = String(message ?? "")
    .replace(/\s*\n+\s*/g, " — ")
    .trim();
  const t = String(title ?? "").trim();
  if (!t) return line;
  if (GENERIC_TITLES.has(norm(t))) return line;
  if (norm(line).startsWith(norm(t.replace(/:$/, "")))) return line;
  return `${t}: ${line}`;
};
